import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  background-color: var(--t-brand-bg-color);
  border-radius: var(--t-cards-border-radius);
  overflow: hidden;
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: translateY(-0.25rem);
  }
`;

export const LinkWrapper = styled.a`
  display: flex;
  flex-direction: row;
  width: 100%;
  text-decoration: none;
  color: inherit;

  &:hover {
    text-decoration: none;
  }
`;

export const ImageWrapper = styled.div`
  width: 100px;
  height: 100px;
  overflow: hidden;
  border-radius: var(--t-images-border-radius) 0 0 var(--t-images-border-radius);

  img {
    width: 100px;
    height: 100px;
    display: block;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 1rem;
  justify-content: center;
  width: 100%;
`;

export const SubheaderWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const BodyWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 0.25rem;
`;
